import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { unFormatCurrency } from '@/common/utils/unFormatters'
import { PaymentAdvanceEstimateData } from '@/features/paymentAdvances/types/paymentAdvanceEstimate.type'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

export type PaymentAdvanceEstimateParams = {
  bill_id: string
  requested_total: string
  date_to_be_paid: string
}

interface UsePaymentAdvanceEstimateProps {
  onSuccess?: (response: AxiosResponse<{ data: PaymentAdvanceEstimateData }>) => void
  onError?: (error: ErrorResponse) => void
}

export const usePaymentAdvanceEstimate = ({ onSuccess, onError }: UsePaymentAdvanceEstimateProps = {}) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['paymentAdvanceEstimate'],
    mutationFn: async (params: PaymentAdvanceEstimateParams) => {
      const { bill_id, requested_total, date_to_be_paid } = params

      return privateAxios.post('/billing/payment_advances/estimate', {
        payment_advance: {
          bill_id,
          requested_total: unFormatCurrency(requested_total),
          date_to_be_paid,
        },
      })
    },
    onSuccess,
    onError,
  })
}
